import { render, staticRenderFns } from "./preloaderComponent.vue?vue&type=template&id=61cf6a96&"
import script from "./preloaderComponent.vue?vue&type=script&lang=js&"
export * from "./preloaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./preloaderComponent.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports